module.exports = __webpack_public_path__ + "media/images/emblems/Soubey-3f6dffe3c5ee4d97b88e7499ceee847d.png";